import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/es/servicios/software-solutions-services/ifucare")({
  head: () => buildRouteHead("/es/servicios/software-solutions-services/ifucare"),
  component: SWOffering,
});

